import { Component, Input } from '@angular/core';
import { SkipNavigationComponent } from '@com-delta-idp/mnx-sitewide-shared-core-ui';

@Component({
  selector: 'idp-skip-navigation-wrapper',
  standalone: true,
  imports: [SkipNavigationComponent],
  templateUrl: './skip-navigation.component.html',
  styleUrl: './skip-navigation.component.scss'
})
export class SkipNavigationSmartComponent {
  @Input() buttonLabel = '';

  focusHeader(): void {
    // Find visible widget (not hidden)
    const visibleWidget = document.querySelector<HTMLElement>(
      'idp-capability-flight-shop:not([hidden]), idp-booking-vacation:not([hidden]), idp-booking-cars:not([hidden]), idp-booking-stays:not([hidden]), idp-capability-my-trips-container:not([hidden]), idp-check-in-container:not([hidden]), idp-flight-status-container:not([hidden])'
    );

    if (visibleWidget) {
      const firstFocusable = visibleWidget.querySelector<HTMLElement>(
        'button:not([disabled]), input:not([disabled]), a:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (firstFocusable) {
        firstFocusable.focus();
        return;
      }
    }

    // Fallback: focus header first focusable
    const fallback = document.querySelector<HTMLElement>(
      '#header-first-focusable'
    );
    fallback?.focus();
  }
}
